/**
 * imageProxy — route CDN images through our backend to bypass throttling/CORS.
 *
 * inorbitonline.com's CDN intermittently 403s or drops connections when the
 * browser fans-out 48+ concurrent <img> requests. The backend `/api/proxy-image`
 * route fetches server-side (where it works reliably), caches, and serves.
 */
import { API_BASE } from './api';

const PROXY_HOSTS = new Set([
    'images.inorbitonline.com',
    'pim.inorbitonline.com',
    'static.wixstatic.com',
    'image.tmdb.org',
]);

export function proxyImg(url) {
    if (!url || typeof url !== 'string') return url;
    try {
        const u = new URL(url, window.location.origin);
        if (!PROXY_HOSTS.has(u.hostname)) return url;
        return `${API_BASE}/proxy-image?src=${encodeURIComponent(url)}`;
    } catch {
        return url;
    }
}
